import React, { useRef, useState, useEffect } from 'react'
import style from './DentalCard.module.css'
import CustomCheckbox from '../../CustomElements/CustomCheckbox/CustomCheckbox'
import Product from '../../Home/Products/Product'
import axios from 'axios'
import { API_BASE_URL } from '../../../lib/constants'

const DentalProductCard = ({ latest_products, price_range, material, categories, setfilterLoading }: any) => {
	// dropdown states

	const [latestProductsData, setLatestProdcutsData] = useState(latest_products?.data)

	const [showPriceDropdown, setShowPriceDropdown] = useState(false)
	const [showCategoryDropdown, setShowCategoryDropdown] = useState(false)

	const [showMaterialDropdown, setShowMaterialDropdown] = useState(false)

	const [priceFilter, setPriceFilter] = useState([])
	const [currentPage, setCurrentPage] = useState(latest_products?.current_page)
	const [lastPage, setLastPage] = useState(latest_products?.last_page)

	const [categoryFilter, setCategoryFilter] = useState([])
	const [materialFilter, setMaterialFilter] = useState([])

	// Search error state
	const [searchError, setSearchError] = useState(false)

	const priceRef = useRef(null)
	const categoryRef = useRef(null)

	const materialRef = useRef(null)
	const searchRef = useRef(null)

	// const router = useRouter()

	const hasActiveFilters = priceFilter.length > 0 || categoryFilter.length > 0 || materialFilter.length > 0 || (searchRef.current && searchRef.current.value.trim() !== '')

	// price func

	const handlePriceClick = async (type: any) => {
		const updatedFilter = priceFilter.includes(type) ? priceFilter.filter((item) => item !== type) : [...priceFilter, type]

		setPriceFilter(updatedFilter)

		await handleFilterData({ price: updatedFilter })
	}

	// category func

	const handleCategoryClick = async (id: any) => {
		const updatedCategoryFilter = categoryFilter.includes(id) ? categoryFilter.filter((item) => item !== id) : [...categoryFilter, id]

		setCategoryFilter(updatedCategoryFilter)

		await handleFilterData({ category: updatedCategoryFilter })
	}

	// material fucn

	const handleMaterialClick = async (type: any) => {
		const updatedMaterialFilter = materialFilter.includes(type) ? materialFilter.filter((item) => item !== type) : [...materialFilter, type]

		setMaterialFilter(updatedMaterialFilter)

		await handleFilterData({ material: updatedMaterialFilter })
	}

	const handleInputChange = async (val: string) => {
		// Clear error if user starts typing
		if (searchError && val.trim() !== '') {
			setSearchError(false)
		}

		// Only clear search if empty (existing logic)
		if (val === '') {
			await handleFilterData({ term: '' })
		}
	}

	const handleFilterData = async ({ price = priceFilter, category = categoryFilter, material = materialFilter, pagination, term }: any) => {
		setfilterLoading(true)
		const data = {
			price_range: price && price.length > 0 ? price : [],
			term: term !== undefined ? term : searchRef?.current?.value || '',
			categories: category && category.length > 0 ? category : [],
			material: material && material.length > 0 ? material : [],
			main_page: '1'
		}
		let res: any
		if (pagination === true) {
			res = await axios.post(`${API_BASE_URL}dental-surgical-instruments-filter?page=${currentPage + 1}`, data)
		} else {
			res = await axios.post(`${API_BASE_URL}dental-surgical-instruments-filter`, data)
		}

		if (pagination === true) {
			setLatestProdcutsData((prevData: any) => [...prevData, ...res?.data?.latest_products?.data])
		} else {
			setLatestProdcutsData(res?.data?.latest_products?.data)
		}

		setCurrentPage(res?.data?.latest_products?.current_page)
		setLastPage(res?.data?.latest_products?.last_page)
		setfilterLoading(false)
	}

	// clear filter
	const handleClearFilters = async () => {
		setMaterialFilter([])
		setCategoryFilter([])
		setPriceFilter([])

		if (searchRef?.current) {
			searchRef.current.value = ''
		}

		setSearchError(false)

		await handleFilterData({
			price: [],
			category: [],
			material: [],
			term: '',
			main_page: '1'
		})
	}

	// handle search
	const handleSearch = async (searchTerm?: string) => {
		const term = searchTerm !== undefined ? searchTerm : (searchRef?.current?.value || '').trim()

		if (term === '') {
			setSearchError(true)
			if (searchRef.current) {
				searchRef.current.focus()
			}
			return
		}

		setSearchError(false)
		await handleFilterData({ term })
	}

	const handleSearchClick = () => {
		handleSearch()
	}

	// Handle Enter key press
	const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key === 'Enter') {
			handleSearch()
		}
	}

	// hide dropdown
	useEffect(() => {
		const handleClickOutside = (e: MouseEvent) => {
			if (showPriceDropdown && priceRef.current && !priceRef.current.contains(e.target as Node)) {
				setShowPriceDropdown(false)
			}
			if (showCategoryDropdown && categoryRef.current && !categoryRef.current.contains(e.target as Node)) {
				setShowCategoryDropdown(false)
			}
			if (showMaterialDropdown && materialRef.current && !materialRef.current.contains(e.target as Node)) {
				setShowMaterialDropdown(false)
			}
		}

		document.body.addEventListener('mousedown', handleClickOutside)
		return () => {
			document.body.removeEventListener('mousedown', handleClickOutside)
		}
	}, [showPriceDropdown, showCategoryDropdown, showMaterialDropdown])

	return (
		<>
			<div className='flex flex-wrap justify-between gap-4'>
				<div className={`flex flex-wrap  justify-between ${style.searchBlogsMain} gap-3`}>
					<div className='  text-black leading-snug bread-leading relative '>
						<input
							type='search'
							ref={searchRef}
							placeholder='Search'
							onChange={(e) => handleInputChange(e.target.value)}
							onKeyPress={handleKeyPress}
							className={`py-2 px-4 focus:outline-none rounded-full lite-blue-bg-color text-gray-600 ${style.widerInput} ${searchError ? 'border-2 border-red-500 focus:border-red-500' : 'border border-gray-300 focus:border-blue-500'}`}
						/>

						<svg xmlns='http://www.w3.org/2000/svg' className=' h-8 w-8 right-2 top-5  absolute   cursor-pointer p-1  transform -translate-y-1/2' fill='none' viewBox='0 0 26 26' stroke='#5F6D7E' onClick={handleSearchClick}>
							<path strokeLinecap='round' strokeLinejoin='round' strokeWidth={1} d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z' />
						</svg>
					</div>

					<div className={style.sort_wrapper}>
						<div className={`${style.dropdown_container} `}>
							<div className={`${style.dropdown_wapper}`} onClick={() => setShowPriceDropdown(!showPriceDropdown)} ref={priceRef}>
								<button className={`mr-3 ${style.dropdown_btn} ${priceFilter && priceFilter?.length > 0 ? style.active_btn : ''} leading-btn bg-transparent  font-medium   py-3 px-6 border  rounded `}>
									<div className={`flex items-center   gap-14 ${style.btn_clr} `}>
										Price Range
										<svg width='12' height='7' viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg'>
											<path d='M11 0.75L6 5.25L1 0.750001' stroke='#5F6D7E' stroke-width='2' />
										</svg>
									</div>
								</button>
							</div>
							<ul className={`${style.dropdown_menu} thin-bar ${showPriceDropdown ? 'show-menu' : 'hide-menu'}`}>
								<li>
									{price_range?.map((type: any, index: number) => {
										return <CustomCheckbox checked={priceFilter.includes(type)} className='checkbox' key={index} type='checkbox' value={type} labeltitle={type} onChange={() => handlePriceClick(type)} />
									})}
								</li>
							</ul>
						</div>

						<div className={`${style.dropdown_container} mt-3 sm:mt-0`}>
							<div className={`${style.dropdown_wapper}`} onClick={() => setShowCategoryDropdown(!showCategoryDropdown)} ref={categoryRef}>
								<button className={`mr-3 ${style.dropdown_btn} ${categoryFilter && categoryFilter?.length > 0 ? style.active_btn : ''} leading-btn bg-transparent  font-medium   py-3 px-6 border  rounded `}>
									<div className={`flex items-center   gap-14 ${style.btn_clr} `}>
										Category
										<svg width='12' height='7' viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg'>
											<path d='M11 0.75L6 5.25L1 0.750001' stroke='#5F6D7E' stroke-width='2' />
										</svg>
									</div>
								</button>
							</div>
							<ul className={`${style.dropdown_menu} thin-bar ${showCategoryDropdown ? 'show-menu' : 'hide-menu'}`}>
								<li>
									{categories?.map((type: any, index: any) => {
										const { id, name } = type
										return <CustomCheckbox checked={categoryFilter.includes(id)} className='checkbox' key={index} type='checkbox' value={''} labeltitle={name} onChange={() => handleCategoryClick(id)} />
									})}
								</li>
							</ul>
						</div>

						<div className={`${style.dropdown_container} mt-3 sm:mt-0`}>
							<div className={`${style.dropdown_wapper}`} onClick={() => setShowMaterialDropdown(!showMaterialDropdown)} ref={materialRef}>
								<button className={`mr-3 ${style.dropdown_btn} ${materialFilter && materialFilter?.length > 0 ? style.active_btn : ''} leading-btn bg-transparent  font-medium   py-3 px-6 border  rounded `}>
									<div className={`flex items-center   gap-14 ${style.btn_clr} `}>
										Material
										<svg width='12' height='7' viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg'>
											<path d='M11 0.75L6 5.25L1 0.750001' stroke='#5F6D7E' stroke-width='2' />
										</svg>
									</div>
								</button>
							</div>
							<ul className={`${style.dropdown_menu} thin-bar ${showMaterialDropdown ? 'show-menu' : 'hide-menu'}`}>
								<li>
									{material?.map((type: any, index: number) => {
										return <CustomCheckbox checked={materialFilter.includes(type)} className='checkbox' key={index} type='checkbox' value={type} labeltitle={type} onChange={() => handleMaterialClick(type)} />
									})}
								</li>
							</ul>
						</div>

						{hasActiveFilters && (
							<div className='text-red-500 font-semibold text-sm cursor-pointer underline mt-3 sm:mt-0' onClick={handleClearFilters}>
								Clear All
							</div>
						)}
					</div>
				</div>
				<div className='featured-category-imgs-container grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 mt-6 gap-4 text-sm leading-snug'>
					{latestProductsData && latestProductsData?.length > 0 ? latestProductsData.map((data: any) => <Product key={data?.id} product={data} />) : <div className='font-semibold text-lg text-red-500'>No product found</div>}
				</div>
			</div>
			{currentPage < lastPage && (
				<div className='flex justify-center items-center mt-3'>
					<button className=' dark-blue-bg mt-6 text-white py-4 px-8 rounded-full shadow-lg cursor-pointer w-max font-bold' onClick={() => handleFilterData({ pagination: true })}>
						View More
					</button>
				</div>
			)}
		</>
	)
}

export default DentalProductCard
